import React from 'react'
import { Box, Button, Grid } from "@mui/material";
import CompanyProfileSectionCard from './CompanyProfileSectionCard';
import companyProfiles from "../../../assets/data/companyProfile";
import { Link } from 'react-router-dom';

function CompanyProfileSection() {
  return (
    <Box
      sx={{
        width: "100%",
        // height: { xs: '125vh', md: "75vh" },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        py: { xs: 4, md: 2},
      }}
    >
      <Grid
        container
        rowSpacing={{ xs: 2, md: 5 }}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        sx={{ mx: 5, my: 5 }}
      >
        {companyProfiles.slice(0, 6).map((companyProfile) => (
          <Grid size={{ xs: 8, md: 6 }} key={companyProfile}>
            <CompanyProfileSectionCard companyProfile={companyProfile} />
          </Grid>
        ))}
      </Grid>
      <Box sx={{ my: { xs: 0, md: 4 } }}>
        <Link to="/company_profiles" >
          <Button
            variant="outlined"
            sx={{ color: "#000", borderColor: "#55d6aa" }}
          >
            Browse More Company Profiles
          </Button>
        </Link>
      </Box>
    </Box>
  )
}

export default CompanyProfileSection
